"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadingModelId = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useOdrModels_1 = require("./useOdrModels");
function useDownloadingModelId() {
    const odrModels = (0, useOdrModels_1.useOdrModels)();
    const odrModel = odrModels === null || odrModels === void 0 ? void 0 : odrModels.find(model => model.status === bridge_schema_1.ODRModelStatus.Downloading);
    return (odrModel === null || odrModel === void 0 ? void 0 : odrModel.identifier) || '';
}
exports.useDownloadingModelId = useDownloadingModelId;
